import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../../../components/TableContent';

interface SkeletonItemDesktopProps {}

export const SkeletonItemDesktop: React.FC<SkeletonItemDesktopProps> = () => {
  return (
    <TableContent direction="row">
      <TableContentItemColumn flex={2}>
        <Skeleton
          w="80%"
          h={Typography['fontsize.lg']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <Skeleton
          w="80%"
          h={Typography['fontsize.lg']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <Skeleton
          w="50%"
          h={Typography['fontsize.lg']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <Skeleton
          w="80%"
          h={Spacing['inline.xxs']}
          borderRadius={BoxRadius.lg}
          endColor={Color['brand.primary.lightest']}
        />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <Skeleton
          w="70%"
          h={Typography['fontsize.lg']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <Skeleton
          w="90%"
          h={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <Skeleton
          w="70%"
          h={Typography['fontsize.lg']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <Skeleton
          w="90%"
          h={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </TableContentItemColumn>
    </TableContent>
  );
};
